module.exports = __webpack_public_path__ + "img/4.a2be47fe.png";